import { createCustomEnum } from "./customEnum";

export type AchRejectStatusesKeys =
	| "new"
	| "pending_documents_or_bank_details"
	| "one_time_debit_attempted"
	| "one_time_debit_failed"
	| "reserves_recovery_in_progress"
	| "residuals_recovery_requested"
	| "partially_recovered"
	| "recovered"
	| "recovered_residuals"
	| "written_off_general"
	| "written_off_fraud"
	| "write_off_recovered"
	| "write_off_recovered_residuals"
	| "collections_letters_sent"
	| "referred_to_3rd_party_collections";

export const AchRejectStatuses = createCustomEnum({
	New: {
		value: "new",
		name: "new",
		displayName: "New",
	},
	PendingDocumentsOrBankDetails: {
		value: "pending_documents_or_bank_details",
		name: "pending_documents_or_bank_details",
		displayName: "Pending Documents / Bank Details",
	},
	OneTimeDebitAttempted: {
		value: "one_time_debit_attempted",
		name: "one_time_debit_attempted",
		displayName: "One Time Debit Attempted",
	},
	OneTimeDebitFailed: {
		value: "one_time_debit_failed",
		name: "one_time_debit_failed",
		displayName: "One Time Debit Failed",
	},
	ReservesRecoveryInProgress: {
		value: "reserves_recovery_in_progress",
		name: "reserves_recovery_in_progress",
		displayName: "Reserves Recovery in Progress",
	},
	ResidualsRecoveryRequested: {
		value: "residuals_recovery_requested",
		name: "residuals_recovery_requested",
		displayName: "Residuals Recovery Requested",
	},
	PartiallyRecovered: {
		value: "partially_recovered",
		name: "partially_recovered",
		displayName: "Partially Recovered",
	},
	Recovered: {
		value: "recovered",
		name: "recovered",
		displayName: "Recovered / Released",
	},
	RecoveredResiduals: {
		value: "recovered_residuals",
		name: "recovered_residuals",
		displayName: "Recovered - Residuals",
	},
	WrittenOffGeneral: {
		value: "written_off_general",
		name: "written_off_general",
		displayName: "Written Off - General",
	},
	WrittenOffFraud: {
		value: "written_off_fraud",
		name: "written_off_fraud",
		displayName: "Written Off - Fraud",
	},
	WriteOffRecovered: {
		value: "write_off_recovered",
		name: "write_off_recovered",
		displayName: "Write Off - Recovered",
	},
	WriteOffRecoveredResiduals: {
		value: "write_off_recovered_residuals",
		name: "write_off_recovered_residuals",
		displayName: "Write Off - Recovered - Residuals",
	},
	CollectionsLettersSent: {
		value: "collections_letters_sent",
		name: "collections_letters_sent",
		displayName: "Collections Letter(s) Sent",
	},
	ReferredTo3rdPartyCollections: {
		value: "referred_to_3rd_party_collections",
		name: "referred_to_3rd_party_collections",
		displayName: "Referred To 3rd Party Collections",
	},
});
